import React from 'react';
import PropTypes from 'prop-types';

import { SkeletonBody } from './styles';

const Skeleton = ({ width, height, marginBottom }) => (
  <SkeletonBody style={{ width, height, marginBottom }} />
);

Skeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.number,
  marginBottom: PropTypes.number,
};

export default Skeleton;
